import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {SubscriptionResponse} from "../interface/subscriptionResponse";
import {AccountType} from "../enums/account-type";

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  private apiUrl = environment.apiUrl + '/subscription';

  constructor(
    private http: HttpClient,
  ) {
  }

  getActiveIndividualSubscription(): Observable<SubscriptionResponse> {
    const path: string = this.apiUrl + '/individual';
    return this.http.get<SubscriptionResponse>(path);
  }

  getActiveTeamSubscriptions(): Observable<Array<SubscriptionResponse>> {
    const path: string = this.apiUrl + '/team';
    return this.http.get<Array<SubscriptionResponse>>(path);
  }

  cancelSubscription(subscriptionId: bigint): Observable<void> {
    return this.http.get<void>(`${this.apiUrl}/cancel?subscriptionId=${subscriptionId}`);
  }

  checkTeamSubscription(teamOwnerId: bigint): Observable<SubscriptionResponse> {
    return this.http.get<SubscriptionResponse>(`${this.apiUrl}/by-team-owner/id/${teamOwnerId}`);
  }

  checkActiveSubscription(accountType: AccountType): Observable<VoidFunction> {
    return this.http.get<VoidFunction>(`${this.apiUrl}/check-active/account-type/${accountType}`);
  }

  download(subscriptionId: bigint): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/download/${subscriptionId}`, {  responseType: 'blob' });
  }
}
